import React from 'react';
import PropTypes from 'prop-types';

const ExtendedTable = ({ Table, wrappers, ...props }) => {
    return (
        <>
            {wrappers}
            <Table {...props} />
        </>
    );
};

ExtendedTable.defaultProps = {
    wrappers: <></>,
    Table: () => <></>,
};

ExtendedTable.propTypes = {
    wrappers: PropTypes.element,
    Table: PropTypes.func,
};

export default ExtendedTable;
